export default {
	name	: 'course-loader',
	data() {
		return {
			currentMessageIndex	: 0,
			progress			: 0,
			loadingMessages		: [
				'Підвантажуємо уроки',
				'Готуємо тести та домашки',
				'Завантажуємо відеоматеріали',
				'Підтягуємо останні оновлення'
			],
			messageInterval		: null,
			progressInterval	: null
		}
	},
	mounted() {
		this.startAnimations();
	},
	beforeDestroy() {
		this.stopAnimations();
	},
	methods: {
		startAnimations() {
			//alert('course-loader');
			
			//this.messageInterval = setInterval(() => {
			//	this.currentMessageIndex = (this.currentMessageIndex + 1) % this.loadingMessages.length;
			//}, 1500);
			
			this.progressInterval = setInterval(() => {
				if (this.progress >= 100) {
					//this.progress = 0;
					
					if(this.currentMessageIndex < (this.loadingMessages.length-1)){
						this.progress = 0;
						this.currentMessageIndex += 1;
					}else{
						clearInterval(this.progressInterval);
						this.progressInterval = null;
					}
				} else {
					this.progress += 2;
					
					if(this.progress > 100){
						this.progress = 100;
					}
				}
			}, 100);
		},
		stopAnimations() {
			if (this.messageInterval) {
				clearInterval(this.messageInterval);
				this.messageInterval = null;
			}
			
			if (this.progressInterval) {
				clearInterval(this.progressInterval);
				this.progressInterval = null;
			}
			
			this.progress = 0;
			this.currentMessageIndex = 0;
		}
	}
}
